"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipPosition = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const debounce_1 = __importDefault(require("lodash/debounce"));
const calcPosition_1 = require("../../utils/calcPosition");
const calcPositionValue_1 = require("../../utils/calcPositionValue");
const outerSize_1 = require("../../utils/outerSize");
var TooltipPosition;
(function (TooltipPosition) {
    TooltipPosition[TooltipPosition["Auto"] = 0] = "Auto";
    TooltipPosition[TooltipPosition["Top"] = 1] = "Top";
    TooltipPosition[TooltipPosition["Right"] = 2] = "Right";
    TooltipPosition[TooltipPosition["Bottom"] = 3] = "Bottom";
    TooltipPosition[TooltipPosition["Left"] = 4] = "Left";
})(TooltipPosition || (exports.TooltipPosition = TooltipPosition = {}));
function Tooltip({ targetElement, position: tooltipPosition, padding = { width: 0, height: 0 }, background, className, opacity, children, }) {
    const [position, setPosition] = (0, react_1.useState)({
        alignment: TooltipPosition.Auto,
        top: 0,
        left: 0,
    });
    const selfRef = (0, react_1.useRef)(null);
    const updatePosition = (0, react_1.useCallback)(() => {
        if (!targetElement || !selfRef.current) {
            return;
        }
        const targetRect = targetElement.getBoundingClientRect();
        const selfRect = selfRef.current.getBoundingClientRect();
        const selfComputedStyle = window.getComputedStyle(selfRef.current);
        const selfOuterSize = (0, outerSize_1.getOuterSize)(selfRect, selfComputedStyle);
        const positionValue = (0, calcPositionValue_1.calcPositionValue)(tooltipPosition, targetRect, selfOuterSize);
        const newPosition = (0, calcPosition_1.calcPosition)(positionValue, selfOuterSize, targetRect);
        setPosition(Object.assign({ alignment: positionValue }, newPosition));
    }, [setPosition, targetElement, tooltipPosition]);
    (0, react_1.useEffect)(() => {
        updatePosition();
        const debouncedHandler = (0, debounce_1.default)(updatePosition, 100);
        window.addEventListener('resize', debouncedHandler);
        return () => {
            window.removeEventListener('resize', debouncedHandler);
        };
    }, [updatePosition]);
    const positionSet = position.left !== 0 || position.top !== 0;
    return ((0, jsx_runtime_1.jsx)(Container, Object.assign({}, position, { background: background, opacity: positionSet ? opacity : 0, padding: padding, className: className, ref: selfRef, role: "tooltip", "data-e2e": 'Tooltip_Container', children: children })));
}
exports.default = Tooltip;
const Container = styled_components_1.default.div `
  position: absolute;
  top: ${({ top }) => top}px;
  left: ${({ left }) => left}px;

  display: flex;
  flex-direction: column;

  margin: 10px;
  padding: ${({ padding }) => padding.height}px
    ${({ padding }) => padding.width}px;

  background-color: ${({ background, theme }) => background || theme.secondary};
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 ${({ theme }) => theme.shadow};

  opacity: ${({ opacity }) => opacity};

  transition: opacity 300ms ease-in;

  &::before {
    position: absolute;

    ${({ alignment, background, theme }) => {
    switch (alignment) {
        case TooltipPosition.Top:
            return (0, styled_components_1.css) `
            bottom: -20px;
            left: calc(50% - 5px);

            border: 10px solid transparent;
            border-top-color: ${background || theme.secondary};
          `;
        case TooltipPosition.Right:
            return (0, styled_components_1.css) `
            left: -20px;
            top: calc(50% - 5px);

            border: 10px solid transparent;
            border-right-color: ${background || theme.secondary};
          `;
        case TooltipPosition.Bottom:
            return (0, styled_components_1.css) `
            top: -20px;
            left: calc(50% - 5px);

            border: 10px solid transparent;
            border-bottom-color: ${background || theme.secondary};
          `;
        case TooltipPosition.Left:
            return (0, styled_components_1.css) `
            right: -20px;
            top: calc(50% - 5px);

            border: 10px solid transparent;
            border-left-color: ${background || theme.secondary};
          `;
        default:
            return (0, styled_components_1.css) ``;
    }
}};

    content: '';
  }
`;
